import { Badge, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { AiAgents, Plus } from "@aircall/react-icons";
import type { PropsWithChildren } from "react";

const EMPTY_AGENT_NAMES: string[] = [];

type VirtualAgentPresenceProps = {
  mainAgentName: string;
  virtualAgentName: string;
  otherAgentNames?: string[];
};

function Layout({ children }: PropsWithChildren) {
  return <div className="flex items-center gap-0.5">{children}</div>;
}

function PlusIcon() {
  return <Plus className="size-3 text-muted-foreground" />;
}

export function VirtualAgentPresence({
  mainAgentName,
  virtualAgentName,
  otherAgentNames = EMPTY_AGENT_NAMES,
}: VirtualAgentPresenceProps) {
  if (mainAgentName && !otherAgentNames.length) {
    return (
      <Layout>
        <span>{mainAgentName}</span>
        <PlusIcon />
        <Tooltip>
          <TooltipTrigger render={<span className="inline-flex" />}>
            <Badge color="green" tone="medium-light" size="default">
              <AiAgents className="text-success" />
            </Badge>
          </TooltipTrigger>
          <TooltipContent>{virtualAgentName}</TooltipContent>
        </Tooltip>
      </Layout>
    );
  }

  if (mainAgentName && otherAgentNames.length) {
    return (
      <Layout>
        <div className="flex items-center gap-0.5">
          <span>{mainAgentName}</span>
          <span className="text-muted-foreground">
            <Tooltip>
              <TooltipTrigger render={<span className="inline-flex" />}>
                <span className="flex items-center">
                  <PlusIcon />
                  {otherAgentNames.length}
                </span>
              </TooltipTrigger>
              <TooltipContent>{otherAgentNames.join(", ")}</TooltipContent>
            </Tooltip>
          </span>
          <PlusIcon />
          <Tooltip>
            <TooltipTrigger render={<span className="inline-flex" />}>
              <AiAgents className="size-4 text-muted-foreground" />
            </TooltipTrigger>
            <TooltipContent>{virtualAgentName}</TooltipContent>
          </Tooltip>
        </div>
      </Layout>
    );
  }

  return null;
}
